import { render, staticRenderFns } from "./ItemAutoCompleteSelector.vue?vue&type=template&id=581ea8a5&scoped=true&lang=pug&"
import script from "./ItemAutoCompleteSelector.vue?vue&type=script&lang=js&"
export * from "./ItemAutoCompleteSelector.vue?vue&type=script&lang=js&"
import style0 from "./ItemAutoCompleteSelector.vue?vue&type=style&index=0&id=581ea8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ea8a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
